import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  recentlyViewedTitle: {
    marginBottom: 30,
    fontSize: 36,
    lineHeight: "1.22",
    fontWeight: 500,
  },
  recentlyViewedContainer: {
    marginBottom: 84,
    [theme.breakpoints.down("sm")]: {
      minHeight: 137,
      margin: "25px 0",
    },
  },
  mobileCenteredText: {
    [theme.breakpoints.down("sm")]: {
      margin: "0 auto",
    },
  },
  footer: {
    marginBottom: 30,
  },
}));
